// extracted by mini-css-extract-plugin
export default {"Layout":"Layout_Layout__AL5cA","App":"Layout_App__7yn7K"};